module.exports = __webpack_public_path__ + "static/Club-Sugar-f73db4b52a490778333d158b6299ad34.jpg";